import _construct from '@babel/runtime/helpers/construct';
import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _defineProperty from '@babel/runtime/helpers/defineProperty';

var and = ' and ';
var modifier = function modifier(isNegative) {
  return "".concat(isNegative === true ? 'not' : 'only', " ");
};
var Query = /*#__PURE__*/_createClass(function Query() {
  var _this = this;
  _classCallCheck(this, Query);
  _defineProperty(this, "mediaType", 'all');
  _defineProperty(this, "isNegative", false);
  _defineProperty(this, "value", '');
  _defineProperty(this, "setType", function (mediaType) {
    _this.mediaType = mediaType;
    return _this;
  });
  _defineProperty(this, "negate", function () {
    _this.isNegative = true;
    return _this;
  });
  _defineProperty(this, "get", function (ignoreModifier) {
    if (ignoreModifier !== false) {
      return modifier(_this.isNegative === true) + _this.mediaType + and + _this.value;
    }
    return _this.value;
  });
  for (var _len = arguments.length, features = new Array(_len), _key = 0; _key < _len; _key++) {
    features[_key] = arguments[_key];
  }
  for (var i = 0, n = features.length; i < n; i += 1) {
    if (i > 0) this.value += and;
    this.value += features[i].get();
  }
});
var query = function query() {
  for (var _len2 = arguments.length, features = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    features[_key2] = arguments[_key2];
  }
  return _construct(Query, features);
};

export { Query, query };
//# sourceMappingURL=Query.js.map
